import CaseletItem from "./CaseletItem";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Caselet, delete_user_data_from_client_side, get_user_data, giveErrorMessage } from "../../utils/common";
// import { checkUser, getUnPublishedCaseletFileInfo, getUnpublishedCaseletsFiles } from "../../api";
import { useCallback, useEffect, useRef, useState } from "react";
import { loadNumberOfFiles } from "../../utils/appConstant";
import InfiniteScroll from "react-infinite-scroll-component";
import MultipleLoadingScreen from "../../design-system/MultipleLoadingScreen";
import { checkUser, getUnPublishedCaseletFileInfo, getUnpublishedCaseletsFiles } from "../../api/axiosApi";

const UnpublishedCaseletList = () => {
    const [caselet, setCaselet] = useState<Caselet[]>([]);
    const [userNotExist, setUserNotExist] = useState<boolean>(false);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [statusCode, setStatusCode] = useState<number | undefined>();
    const [hasMore, setHasMore] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    let fileIndex = 0;

    const fetchAndSetCaselets = async () => {
        try {
            if (get_user_data() !== null && get_user_data() !== undefined) {
            const check_user = await checkUser();
            const checkUserExist = await check_user.data;
            if (!checkUserExist.exists) {
                setUserNotExist(true);
            }
            let caseletFilesResponse;

            caseletFilesResponse = await getUnpublishedCaseletsFiles();

            // if (!caseletFilesResponse.ok) {
            //     setStatusCode(caseletFilesResponse.status);
            //     throw new Error(`Error! status: ${caseletFilesResponse.status}`);
            // }
            const caseletFiles = await caseletFilesResponse.data;

            caseletFiles.sort((a: any, b: any) => {
                const timestampA = Number(a.slice(0, -4)); // Remove '.txt' and convert to number
                const timestampB = Number(b.slice(0, -4)); // Remove '.txt' and convert to number
                return timestampB - timestampA; // Sort in descending order (most recent first)
            });
            const fetchedCaselets: Caselet[] = [];
            let caseletInfoResponse: Response | undefined | any;
            for (let i = 0; i < Math.min(caseletFiles.length, loadNumberOfFiles) && fileIndex < caseletFiles.length; i++) {
                try {
                    caseletInfoResponse = await getUnPublishedCaseletFileInfo(caseletFiles[fileIndex].substring(0, caseletFiles[fileIndex].lastIndexOf(".")));
                    const caseletInfo = await caseletInfoResponse.data;
                    if (caseletInfo.id === undefined) {
                        fileIndex++;
                        continue;
                    }
                    caseletInfo.fileName = caseletFiles[fileIndex].substring(0, caseletFiles[fileIndex].lastIndexOf("."));
                    fetchedCaselets.push(caseletInfo);
                } catch (error) {
                    console.error(`Failed to fetch caselet data `, error);
                }
                fileIndex++;
            }
            setCaselet(prevCaselet => [...prevCaselet, ...fetchedCaselets]);
            setIsLoading(false);
            if (caseletFiles.length <= fileIndex) {
                setHasMore(false);
                return;
            }
        }else{
            navigate("/user_login")
        }
        } catch (error) {
            setError(true);
            console.error(`Failed to fetch caselet files `, error);
        }

    };

    useEffect(() => {
        if (hasMore) {
            fetchAndSetCaselets();
        }
    }, [location]);
    const fetchMoreData = useCallback(() => {
        if (hasMore) {
            fetchAndSetCaselets();
        }
    }, [hasMore]);
    if (isLoading && error === false) {
        return (
            <div className="p-4">
                <MultipleLoadingScreen count={3} />
            </div>
        );
    }

    if (error) {
        return giveErrorMessage(statusCode);
    }
    return (
        <div className=" ">
            <div className="flex-grow pb-8 relative">
                <InfiniteScroll
                    dataLength={caselet.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        <div className="p-4">
                            <MultipleLoadingScreen count={3}/>
                        </div>
                    }
                >
                    {caselet.map(caseletObject => (
                        <CaseletItem key={caseletObject.id} caselet={caseletObject} />
                    ))}
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default UnpublishedCaseletList;
